import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from "react";
const GameContextListenerContext = createContext(null);
export function withGameContextListenerProvider(listener, children) {
    return _jsx(GameContextListenerContext.Provider, { value: listener, children: children });
}
export function useGameContext(key) {
    const gameContextListener = useContext(GameContextListenerContext);
    return gameContextListener.useGameContext(key);
}
export function useCreatedEvent(key) {
    const gameContextListener = useContext(GameContextListenerContext);
    return gameContextListener.useCreatedEvent(key);
}
export function useDeletedEvent(key) {
    const gameContextListener = useContext(GameContextListenerContext);
    return gameContextListener.useDeletedEvent(key);
}
//# sourceMappingURL=useGameContext.js.map